import React, { useCallback, useMemo } from "react"

import { JsonCodeEditor } from "@/components/JsonCodeEditor"
import { FieldLabel } from "@/components/shared/forms/FieldLabel"

import { WEBSOCKET_TOOLTIPS } from "./tooltips"
import { DEFAULT_DTMF_TEMPLATE, type WebSocketFieldProps } from "./types"
import { validateDtmfTemplate } from "./utils"

export const DtmfFormatFields: React.FC<WebSocketFieldProps> = ({
  metadata,
  onMetadataUpdate,
  disabled = false,
}) => {
  const dtmfTemplateError = useMemo(
    () => validateDtmfTemplate(metadata.send_dtmf_template || ""),
    [metadata.send_dtmf_template],
  )

  const handleDtmfTemplateChange = useCallback(
    (value: string) => {
      onMetadataUpdate({ send_dtmf_template: value })
    },
    [onMetadataUpdate],
  )

  return (
    <div className="space-y-4">
      <h4 className="text-sm font-medium text-coval-text">DTMF Format</h4>

      <div className="space-y-2">
        <FieldLabel tooltip={WEBSOCKET_TOOLTIPS.sendDtmfTemplate}>
          DTMF Send Template
        </FieldLabel>
        <JsonCodeEditor
          ariaLabel="DTMF Send Template"
          placeholder={DEFAULT_DTMF_TEMPLATE}
          value={metadata.send_dtmf_template || ""}
          onChange={handleDtmfTemplateChange}
          rows={4}
          disabled={disabled}
          error={dtmfTemplateError}
          // `{{digit}}` may stand in for a whole value, which a plain parse
          // rejects; validateDtmfTemplate substitutes it first.
          lint={false}
        />
        <p className="text-xs text-coval-text-muted">
          JSON template for sending keypad digits. Must contain the{" "}
          <code className="bg-surface-1 px-1 rounded">{"{{digit}}"}</code>{" "}
          placeholder. One frame is sent per key press.
        </p>
      </div>
    </div>
  )
}
